var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTransferPointsWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 301 249",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.526 0L173.051 20.2104L231.472 81.1573H0V110.21H299.998L194.526 0Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.477 248.207L126.951 227.997L68.5307 167.05H300.003V137.998H0.00488281L105.477 248.207Z",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransferPointsWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TransferPointsWhite.2f535b63.svg";
export { ForwardRef as ReactComponent };